import React from "react";
import { useState } from "react";
import { Grid } from "@material-ui/core";

const FormInput = (props) => {
  const [focused, setFocused] = useState(false);
  const { label, errorMessage, onChange, id, ...inputProps } = props;

  const handleFocus = (e) => {
    setFocused(true);
  };

  return (
     <Grid item md={6} xs={12}>
    <div className="formInput">

      <label>{label}</label>
      <input
        {...inputProps}
        className="form-field"
        onChange={onChange}
        onBlur={handleFocus}
        onFocus={() =>
          inputProps.name === "confirmPassword" && setFocused(true)
        }
        focused={focused.toString()}
      />
      <span>{errorMessage}</span>
    </div>
     </Grid>
  );
};

export default FormInput;